// Todo: make typed

function isMinSizeArray(array: any[], dimension: number) {
    return array.length >= dimension;
}

export function smooth(
    path: number[][],
    { factor = 0.75, iteration = 1, dimension }: { factor: number; iteration: number; dimension: number }
) {
    if (dimension && !path.every((point) => isMinSizeArray(point, dimension))) {
        throw new Error('Dimension min size Error');
    }

    while (iteration > 0) {
        path = singlesmooth(path, factor, dimension);
        iteration--;
    }
    return path as [number, number][];
}

function singlesmooth(points: number[][] = [], factor = 0.75, dimension: number) {
    const output = [];
    if (points.length > 0) {
        output.push(Array.from(points[0]));
    }

    for (const i in points) {
        const current = dimension ? points[i].slice(0, dimension) : points[i];
        const next = points[Number(i) + 1];
        if (!next) {
            break;
        }

        const Q = current.map((c, index) => calculateMidValue(c, next[index], factor));
        const R = current.map((c, index) => calculateMidValue(next[index], c, factor));
        output.push(Q, R);
    }
    if (points.length > 1) {
        output.push(Array.from(points[points.length - 1]));
    }

    return output;
}

function calculateMidValue(x: number, y: number, factor: number) {
    let corr = 0;
    if (Math.abs(x - y) > 180) {
        if (x > 0) {
            y += 360;
            corr = -360;
        } else {
            y -= 360;
            corr = 360;
        }
    }
    return corr + factor * x + (1 - factor) * y;
}
